import React from 'react';
import cl from './ErrorBoundary.module.css';
import logger from '../../utils/logger';

// React Error Boundary — ловит любые ошибки рендера/lifecycle ВНИЗ по дереву.
// Без него любой throw в любом компоненте даёт белый экран на весь app.
//
// Использование:
//   <ErrorBoundary>
//     <Routes>...</Routes>
//   </ErrorBoundary>
//
// Технология: классовый компонент (Error Boundary всё ещё требует class в React).
// Хуковая альтернатива возможна только через react-error-boundary (npm-пакет).

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    // Когда ребёнок выбросил — переключаем стейт.
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    // Здесь же логируем — это место отправки в Sentry, когда подключим.
    componentDidCatch(error, info) {
        logger.error('[ErrorBoundary] uncaught:', error, info?.componentStack);
    }

    handleReload = () => {
        // Сбрасываем стейт + перезагружаем чтобы вернуться в чистое состояние.
        // Просто сбросить state недостаточно — компонент может упасть снова
        // на тех же данных. Reload надёжнее.
        window.location.reload();
    };

    handleGoHome = () => {
        window.location.replace('/main');
    };

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        const message = this.state.error?.message || String(this.state.error || 'Неизвестная ошибка');

        return (
            <div className={cl.wrap}>
                <div className={cl.card}>
                    <div className={cl.emoji}>⚠️</div>
                    <h1 className={cl.title}>Что-то пошло не так</h1>
                    <p className={cl.text}>
                        Произошла внутренняя ошибка приложения. Мы уже знаем
                        о ней. Попробуйте перезагрузить страницу — обычно
                        этого хватает. Если ошибка повторяется, напишите
                        на <a href="mailto:maksimivankov26@yandex.ru" className={cl.link}>
                            maksimivankov26@yandex.ru
                        </a>.
                    </p>

                    {/* Технические подробности — только в dev-режиме, чтобы
                        не пугать обычных пользователей. */}
                    {process.env.NODE_ENV !== 'production' && (
                        <details className={cl.details}>
                            <summary>Технические подробности</summary>
                            <pre className={cl.pre}>{message}</pre>
                        </details>
                    )}

                    <div className={cl.actions}>
                        <button className={cl.btnPrimary} onClick={this.handleReload}>
                            Перезагрузить страницу
                        </button>
                        <button className={cl.btnGhost} onClick={this.handleGoHome}>
                            На главную
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
